// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-responsive {\n  padding: 0 1.25rem 0 calc(clamp(260px, 20vw, 300px) + 20px);\n  height: 100%;\n  overflow-y: auto;\n}\n.nav-responsive.mobile-active {\n  padding: 0 1rem;\n}\n.route-view-shell {\n  min-height: 100%;\n  width: 100%;\n}\n@media (min-width: 1536px) {\n.nav-responsive {\n    padding-left: calc(clamp(260px, 15vw, 300px) + 20px);\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
